var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('px-card',{staticClass:"indexCard"},[_c('h6',[_vm._v(_vm._s(_vm.institution.title))]),_c('Icon',{staticClass:"clickable",attrs:{"name":"trashCanOutline"},nativeOn:{"click":function($event){return _vm.removeInstitution($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }